import React from 'react';
import PropTypes from 'prop-types';
import {useIntl} from 'react-intl';


import {contactFormConstants} from '../../Contact/ContactForm';
import {inputConstants} from '../../../global/Form/Input';
import {SCHEMA_USER_FORM} from './userFormConstants';

import EmailConfirmationForm from '../../Email/EmailConfirmationForm';
import FormBlock from '../../../global/Form/FormBlock';
import FormTextInput from '../../../global/Form/FormElement/FormTextInput';
import PasswordConfirmationForm from '../PasswordConfirmationForm';
import ValidatingForm from '../../../global/Form/ValidatingForm';

import {I18nMessage, LanguageSelectForm} from '../../I18n';
import {PhoneForm} from '../../Contact/Phone/PhoneForm';


function UserForm({onChange, user}) {

    const {formatMessage} = useIntl();

    return (
        <ValidatingForm
            data={user}
            id={'user.form'}
            onIsInValid={data => onChange(data, false)}
            onIsValid={data => onChange(data, true)}
            validationSchema={SCHEMA_USER_FORM}
        >
            {({form}) => (
                <>

                    <FormBlock>

                        <legend>
                            <I18nMessage id={'user.form.personal.legend'}/>
                        </legend>

                        <FormTextInput
                            autocomplete={inputConstants.AUTOCOMPLETE_NAME}
                            error={form.getCurrentError('name')}
                            id={'name'}
                            isRequired={form.isRequired('name')}
                            labelI18n={'user.form.field.name.label'}
                            maxLength={contactFormConstants.NAME_MAX_LENGTH}
                            name={'name'}
                            onChange={name => form.setData({name})}
                            placeholder={formatMessage({id: 'user.form.field.name.placeholder'})}
                            value={form.getData('name')}
                        />

                        <FormTextInput
                            autocomplete={inputConstants.AUTOCOMPLETE_SURNAME}
                            error={form.getCurrentError('surname')}
                            id={'surname'}
                            isRequired={form.isRequired('surname')}
                            labelI18n={'user.form.field.surname.label'}
                            maxLength={contactFormConstants.SURNAME_MAX_LENGTH}
                            name={'surname'}
                            onChange={surname => form.setData({surname})}
                            placeholder={formatMessage({id: 'user.form.field.surname.placeholder'})}
                            value={form.getData('surname')}
                        />

                        <PhoneForm
                            autocomplete={inputConstants.AUTOCOMPLETE_TEL}
                            error={form.getCurrentError('phone', 'phone.form', 'number')}
                            id={'phoneNumber'}
                            isRequired={form.isRequired('phone')}
                            labelI18n={'phone.form.field.number.label'}
                            name={'phoneNumber'}
                            onChange={phone => form.setData({phone})}
                            placeholder={formatMessage({id: 'phone.form.field.number.placeholder'})}
                            value={form.getData('phone')}
                        />

                    </FormBlock>
                    <FormBlock>

                        <legend>
                            <I18nMessage id={'user.form.credentials.legend'}/>
                        </legend>

                        <EmailConfirmationForm
                            data={
                                {
                                    email: form.getData('email', ''),
                                    emailConfirmation: form.getData('emailConfirmation', '')
                                }
                            }
                            onChange={({email}, isValid) => {

                                form.setData({
                                    email: isValid ? email : undefined,
                                    emailConfirmation: isValid ? email : undefined
                                });
                            }}
                        />

                        <PasswordConfirmationForm
                            data={
                                {
                                    password: form.getData('password', ''),
                                    passwordConfirmation: form.getData('passwordConfirmation', '')
                                }
                            }
                            onData={({password}, isValid) => {

                                form.setData({
                                    password: isValid ? password : undefined,
                                    passwordConfirmation: isValid ? password : undefined
                                });
                            }}
                        />

                        <LanguageSelectForm
                            id={'registrationUserLocale'}
                            labelI18n={'user.form.locale'}
                            onChange={locale => form.setData({locale})}
                            value={form.getData('locale')}
                        />

                    </FormBlock>

                    <p className={'form-text-description'}>
                        <I18nMessage id={'user.form.credentials.securityNote'}/>
                    </p>

                </>
            )}
        </ValidatingForm>
    );
}


UserForm.propTypes = {
    onChange: PropTypes.func.isRequired,
    user: PropTypes.object
};


export default UserForm;
